/*
 *   File : edit-subadmin-details.js
 *   Description : Edit subadmin details modal
 */

import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { Icon } from "../Icon";
import { CustomTextInput, CustomSearchSelectBox, CustomPhoneInput } from "../FormElements";
import { GradientButton, OutlineButton } from "../Cta";

import { closeModal } from "../../Helper/helper-function";
import style from "../../Styles/Components/update-rm.module.scss";
// import { _getAdminTypes } from "../../Helper/api";
import APIService from "../../Services/api-service";

const EditSubAdminDetailsModal = (props) => {



    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");

    const [adminTypes, setAdminTypes] = useState([]);
    const [selectedAdminType, setSelectedAdminType] = useState('');
    const [selectedAdminError, setSelectedAdminError] = useState('');
    const [mobile, setMobile] = useState("");
    const [mobileError, setMobileError] = useState("");

    const [mtId, setMtId] = useState("");
    const [mtIdError, setMtIdError] = useState("");


    console.log('adminTypes', adminTypes);

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState("");

    const [apiLoader, setApiLoader] = useState(false);


    useEffect(() => {
        _fetchAdminTypes();
    }, []);

    // async function _fetchAdminTypes() {
    //     let admin_data = await _getAdminTypes();
    //     if (admin_data.length !== 0) {
    //         admin_data.forEach(item => {
    //             item.label = item.name;
    //             delete item.name;
    //         });
    //         setAdminTypes(admin_data);
    //     } else {
    //         setAdminTypes([]);
    //     }
    // }

    const _fetchAdminTypes = () => {
        const url = 'auth/admin-types-filter';

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                const admin_types = response.data.map(item => ({
                    value: item.id,
                    label: item.name
                }));
                setAdminTypes(admin_types);
            } else {
                setAdminTypes([]);
            }
        });
    };


    useEffect(() => {
        const modal = document.getElementById("edit-subadmin-details");
        modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, []);


    useEffect(() => {
        if (props.editData && adminTypes.length !== 0) {
            setName(props.editData.name || "");
            setEmail(props.editData.email || "");
            setMobile(props.editData.phone || "");
            setMtId(props.editData.admin_mt_id || "");

            const selectedType = adminTypes.find(
                item =>
                    item.value === props.editData.admin_type_id ||
                    item.label === props.editData.admin_type
            );

            if (selectedType) {
                setSelectedAdminType(selectedType);
            }
        }
    }, [props.editData, adminTypes]);



    function _handleAdminTypeChange(value) {
        setSelectedAdminType(value);
        setSelectedAdminError('');
    }


    const _handleCancel = () => {
        closeModal("edit-subadmin-details");
        props.close();
    };


    const _validateForm = () => {
        let valid = true;

        if (!name.trim()) {
            setNameError("Enter name");
            valid = false;
        }

        if (selectedAdminType === '') {
            setSelectedAdminError("Admin type is required");
            valid = false;
        }

        if (!email.trim()) {
            setEmailError("Enter email");
            valid = false;
        }

        if (!mobile || mobile.length < 10) {
            setMobileError("Enter valid phone number");
            valid = false;
        }

        if (!mtId.trim()) {
            setMtIdError("Enter MT ID");
            valid = false;
        }

        if (valid) {
            _handleSubmit();
        }
    };


    const _handleSubmit = () => {
        setApiLoader(true);

        let is_post = true;
        let url = 'auth/admin-details-edit';
        const payload = {
            name,
            email,
            admin_type_id: selectedAdminType.value,
            sub_admin_id: props.editData?.admin_id,
            phone: mobile,
            mt_id: mtId
        };
        APIService(is_post, url, payload).then((response) => {
            setApiLoader(false);

            if (response.status_code === 200) {
                closeModal("edit-subadmin-details");
                props.handleUpdate();
                props.close();
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        });


        // API call placeholder
        // setTimeout(() => {
        //     toast.success("Details updated successfully");
        //     setApiLoader(false);
        //     props.close();
        // }, 800);
    };

    return (
        <div
            className={`modal fade ${style.e_update_rm}`}
            id="edit-subadmin-details"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content bg-white padding-32px-all">

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <p className="e-poppins-medium e-font-18 mb-0">
                            Edit Subadmin Details
                        </p>
                        <Icon
                            icon="close"
                            size={24}
                            data-bs-dismiss="modal"
                            className="cursor-pointer"
                        />
                    </div>

                    {/* Name */}
                    <div className="mt-3">
                        <CustomTextInput
                            value={name}
                            label="Name"
                            postfix="*"
                            error={nameError}
                            onEnter={_validateForm}
                            valueChange={(val) => {
                                setName(val);
                                setNameError("");
                            }}
                        />
                    </div>

                    {/* Type */}
                    <div className="mt-4">
                        <CustomSearchSelectBox
                            label="Additional information"
                            value={selectedAdminType}
                            placeholder=""
                            id="admin-type-input"
                            error={selectedAdminError}
                            options={adminTypes}
                            postfix="*"
                            onSelectChange={_handleAdminTypeChange}
                        />
                    </div>

                    {/* Email */}
                    <div className="mt-4 pt-2">
                        <CustomTextInput
                            value={email}
                            label="Email"
                            postfix="*"
                            error={emailError}
                            onEnter={_validateForm}
                            valueChange={(val) => {
                                setEmail(val);
                                setEmailError("");
                            }}
                        />
                    </div>


                    <div className="mt-4 pt-2">
                        <CustomPhoneInput
                            label="Phone number"
                            postfix="*"
                            value={mobile}
                            error={mobileError}
                            handleChange={(value) => {
                                setMobile(value);
                                setMobileError("");
                            }}
                        />
                    </div>

                    <div className="mt-4 pt-2">
                        <CustomTextInput
                            value={mtId}
                            postfix="*"
                            label="MT ID"
                            error={mtIdError}
                            onEnter={_validateForm}
                            valueChange={(val) => {
                                setMtId(val);
                                setMtIdError("");
                            }}
                        />
                    </div>



                    {/* Buttons */}
                    <div className="d-flex justify-content-center gap-8px margin-32px-top">
                        <OutlineButton
                            label="Cancel"
                            className="padding-12px-tb px-3 e-font-16"
                            onPress={_handleCancel}
                        />
                        <GradientButton
                            label="Submit"
                            loading={apiLoader}
                            className="padding-12px-tb e-font-16"
                            onPress={_validateForm}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default EditSubAdminDetailsModal;
